import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Menu } from 'antd';

class ResendRecordsMenu extends PureComponent {
  render() {
    const {
      openMenu,
      handleResendRecord,
      handleRequestChange,
      disableSingleResend,
      children,
    } = this.props;
    const overlay = (
      <Menu onClick={handleResendRecord}>
        <Menu.Item key="1" disabled={disableSingleResend}>Resend selected record</Menu.Item>
        <Menu.Item key="3" disabled={!disableSingleResend}>Resend all records not viewed in 3 Days</Menu.Item>
        <Menu.Item key="7" disabled={!disableSingleResend}>Resend all records not viewed in 7 Days</Menu.Item>
        <Menu.Item key="10" disabled={!disableSingleResend}>Resend all records not viewed in 10 Days</Menu.Item>
      </Menu>
    );
    return (
      <Dropdown
        overlay={overlay}
        visible={openMenu}
        onVisibleChange={handleRequestChange}
        trigger={['click']}
        placement="bottomRight"
      >
        {children}
      </Dropdown>
    );
  }
}

ResendRecordsMenu.propTypes = {
  handleResendRecord: PropTypes.func.isRequired,
  handleRequestChange: PropTypes.func.isRequired,
  openMenu: PropTypes.bool.isRequired,
  disableSingleResend: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,

};

export default ResendRecordsMenu;
